<template>
  <el-form
    :model="accountForm"
    status-icon
    :rules="rules"
    ref="companyDetailsForm"
  >
    <el-row class="layout__padding-0-50px el-row--flex justify-center">
      <el-col :span="5">
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Company name
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Branch name
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Delivery address 1
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Delivery address 2
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Town
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Postcode
        </div>
      </el-col>

      <el-col
        :span="7"
        class="layout__padding__right-20px"
      >
        <el-form-item
          prop="company_name"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Company name"
            v-model="accountForm.company_name"
          />
        </el-form-item>
        <el-form-item
          prop="branch_name"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Branch name"
            v-model="accountForm.branch_name"
          />
        </el-form-item>
        <el-form-item
          prop="branch_address1"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Delivery address 1"
            v-model="accountForm.branch_address1"
          />
        </el-form-item>
        <el-form-item
          prop="branch_address2"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Delivery address 2"
            v-model="accountForm.branch_address2"
          />
        </el-form-item>
        <el-form-item
          prop="branch_town"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Town"
            v-model="accountForm.branch_town"
          />
        </el-form-item>
        <el-form-item
          prop="branch_postcode"
        >
          <el-input
            class="layout__max-width-250px"
            placeholder="Postcode"
            v-model="accountForm.branch_postcode"
          />
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        />
        <el-checkbox
          class="layout__border__bottom-none text__direction-left-to-right p-0"
          @change="steBranch"
        >
          <span class="layout__padding__left-20px font-12-required">
            Same as company name
          </span>
        </el-checkbox>
      </el-col>
    </el-row>

    <div class="d-flex justify-center">
      <el-button
        class="button__background-tickled-pink layout__width-150px"
        @click="next"
      >
        Next
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'CompanyDetails',

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },

    finalForm: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      accountForm: {
        company_name: '',
        branch_name: '',
        branch_address1: '',
        branch_address2: '',
        branch_town: '',
        branch_postcode: '',
      },
      rules: {
        company_name: [
          { required: true, message: 'Company name required', trigger: 'blur' }
        ],
        branch_name: [
          { required: true, message: 'Branch required', trigger: 'blur' }
        ],
        branch_address1: [
          { required: true, message: 'Delivery address 1 required', trigger: 'blur' }
        ],
        branch_town: [
          { required: true, message: 'Town required', trigger: 'blur' }
        ],
        branch_postcode: [
          { required: true, message: 'Postcode required', trigger: 'blur' }
        ],
      },
    };
  },

  methods: {
    next() {
      this.$refs.companyDetailsForm.validate((valid) => {
        if (! valid || this.isLoading) {
          return;
        }

        this.$emit('step-passed', {
          userData: this.accountForm,
          saveUser: false,
          finishRegistration: false,
          nextStep: 'billing-details',
        });
      });
    },

    steBranch(val) {
      if (val) {
        this.accountForm.branch_name = this.accountForm.company_name;
      }
    },
  },
};
</script>